import { Navigate } from 'react-router-dom';
import { usePermission } from '@/hooks/usePermission';
import { AppRoutes } from '@/constants/routes';

interface Props {
  permission: string;
  children: React.ReactNode;
}

/**
 * Wraps a route element and redirects to /access-denied if the
 * current user lacks the required permission.
 */
export const RequirePermission = ({ permission, children }: Props) => {
  const { hasPermission } = usePermission();
  if (!hasPermission(permission)) {
    return <Navigate to={AppRoutes.ACCESS_DENIED} replace />;
  }
  return <>{children}</>;
};
